import React, { Component } from 'react';
import {unlockCollateral} from '../../../../actions/orderbook/set';
import Modal from '../../../helper/modal';
import M from 'materialize-css/dist/js/materialize.min.js'
import $ from 'jquery';
import { connect } from 'react-redux';
import {colors} from '../../../../config'

const {green} = colors;

class Orders extends Component {
  constructor(){
    super()
    this.state = {}
  }
  renderUnlock(){
    return (
      <Modal id='modalUnlock2' noClose={true} classes='modal modalOrders black-text' title='Unlock Confirmation' decryption={true} buttonText={"Confirm"} passwordId='unlockpass2' buttonAction={this.submitOperationUnlock.bind(this)} />
    )
  }
  submitOperationUnlock(){
    let password = $("#unlockpass2").val();
    this.props.unlockCollateral({password,txHash:this.state.txHash,txOutputIndex:this.state.txOutputIndex},(err,tx)=>{
      if(!err) {
        var instance = M.Modal.getInstance(document.querySelectorAll('#modalUnlock2')[0]);
        if(instance) instance.close();
        $("#unlockpass2")[0].value = '';
        M.toast({html: 'Transaction Submitted!',classes: "green",displayLength:3000});
      }
      else {
        M.toast({html: err,classes:"red",displayLength:3000});
      }
    })
  }
  handleFormSubmitUnlock({txHash,txOutputIndex}) {
    this.setState({txHash,txOutputIndex});
    var instance = M.Modal.getInstance(document.querySelectorAll('#modalUnlock2')[0]);
    if(instance) instance.open();
    setTimeout(()=>{
      if($("#unlockpass2")) $("#unlockpass2").focus()
    },100)
  }
  renderItem(offers){
    var items = offers.map(({receivesUnit,sendsUnit,sendsFromChain,receivesToChain,collateralizedNrg,depositLeft,settleLeft},i) => {
      return (
        <tr>
          <td >{sendsUnit} <span > {sendsFromChain.toUpperCase()}</span></td>
          <td>{receivesUnit} <span > {receivesToChain.toUpperCase()} </span> </td>
          <td>{collateralizedNrg} NRG</td>
          <td>{depositLeft}</td>
          <td>{settleLeft}</td>
        </tr>
      );
    });
    return items;
  }
  renderItemUnlock(offers){
    var items = offers.map(({receivesUnit,sendsUnit,sendsFromChain,receivesToChain,isSettled,collateralizedNrg,depositLeft,settleLeft,txHash,txOutputIndex},i) => {
      let unlockClick = this.handleFormSubmitUnlock.bind(this,{txHash,txOutputIndex})
      return (
        <tr>
          <td >{sendsUnit} <span > {sendsFromChain.toUpperCase()}</span></td>
          <td>{receivesUnit} <span > {receivesToChain.toUpperCase()} </span> </td>
          <td>{collateralizedNrg} NRG</td>
          <td>{isSettled ?  <a style={{color:green,cursor:'pointer'}} onClick={unlockClick}><u>Unlock Collateral</u></a> : `Unlock ${settleLeft}`}</td>
        </tr>
      );
    });
    return items;
  }
  render() {
    let items = this.props.unlock ? this.renderItemUnlock(this.props.orders) : this.renderItem(this.props.orders)
    return (
      <div>
      <table className="white-text order-book striped" style={{tableLayout:"fixed",fontSize:"0.9em",height:'30px',lineHeight:'30px'}}>
        <tbody>
          {items}
        </tbody>
      </table>
      {this.props.unlock && this.renderUnlock()}
      </div>
    )
  }
}

function mapStateToProps(state,props) {
  return {
  };
}

export default connect(mapStateToProps, {
  unlockCollateral
})(Orders);
